import React from 'react';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary.main,
  },
}));


export default function ProgressFullScreen(props) {
  const classes = useStyles();
  const {open} = props;
  return (
    <Backdrop
      className={classes.backdrop}
      open={open}
      >
      <Grid
        container
        spacing={2}
      >
        <Grid
          item
          md={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <CircularProgress style={{ color: "#FFFFFF" }} />
        </Grid>
        <Grid
          item
          md={12}
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Typography className={classes.title} variant="h4" style={{ color: "#FFFFFF" }} gutterBottom id='tituloTabelaEstoqueMovimentacao'>
            {`Carregando...` }
          </Typography>
        </Grid>
      </Grid>
    </Backdrop>
  );
}
